<div class="col-auto my-2 has-validation">
  @if (label(); as label) {
    <label
      class="form-label"
      [class.required]="hasRequiredValidator()"
      for="{{ inputFormControlName() }}"
    >
      {{ label | translate }}
    </label>
  }
  <input
    class="form-control"
    [class.is-invalid]="
      inputFormControl().hasError('codeTaken') ||
      inputFormControl().hasError('maxlength') ||
      inputFormControl().hasError('minlength') ||
      inputFormControl().hasError('email') ||
      inputFormControl().hasError('mailUsed') ||
      inputFormControl().hasError('mismatch') ||
      inputFormControl().hasError('invalidTwoFactorCode') ||
      (inputFormControl().hasError('required') && inputFormControl().touched)
    "
    [type]="type()"
    [placeholder]="placeholder() | translate"
    id="{{ inputFormControlName() }}"
    [formControl]="inputFormControl()"
    [attr.required]="hasRequiredValidator()"
    (keydown.enter)="omitKeydownEnter() ? onEnterKey($event) : null"
    [attr.maxlength]="maxlength() ? maxlength() : null"
  />

  @if (inputFormControl().touched && inputFormControl().invalid) {
    <div class="feedback">
      @if (errorKeys().length > 0) {
        <div>
          {{ getErrorMessage(errorKeys()[0]) | translate }}
        </div>
      }
    </div>
  } @else if (leaveSpaceForValidation()) {
    <div class="placeholder-feedback"></div>
  }
</div>
